
import React, { useState } from 'react';
import '../styles/contact.css';
import phoneimg from '../assest/phone.png';
import emailimg from '../assest/email.png';
import addressimg from '../assest/addree.png';

function Contact() {
const [status, setStatus] = useState("");

  const countries = ['India', 'United States', 'United Kingdom', 'Australia', 'Canada', 'Germany', 'France', 'China', 'Brazil', 'Japan', 'Mexico', 'Russia', 'South Africa', 'Italy', 'Spain', 'Netherlands'];



  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    cell: "",
    email: "",
    country: "",

    preferredContact: "Call",
    message: ""
  });

  const [show, setShow] = useState(false);

const [hideTimeout, setHideTimeout] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  const sendEmail = async (e) => {
    e.preventDefault();
     const phoneRegex = /^\d{10}$/;
  if (!phoneRegex.test(formData.cell)) {
    setStatus('Please enter a valid 10-digit mobile number.');
    return;
  }

    //const res = await fetch("/register", {   // Uncomment this line for local testing
    const res = await fetch("https://cz-engine.onrender.com/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    const data = await res.json();
    console.log(data);


    // FOR POP UP


    // if (data.status === 401 || !data) {
    //     console.log("Error sending email");
    // } else {
    //     setShowModal(true);
    //     setFormData({
    //         name: "",
    //         lastname: "",
    //         cell: "",
    //         email: "",
    //         country: "",
    //         preferredContact: "",
    //         message: ""
    //     });
    //     console.log("Email sent successfully");

    //FOR ALERT

    if (data.status === 401 || !data) {
      console.log("Error sending email");
    } else {
      setShowModal(true);
      // setTimeout(() => {
      //   setShowModal(false);
      // }, 5000);
      const timeoutId = setTimeout(() => {
  setShowModal(false);
}, 5000);

setHideTimeout(timeoutId);

      setFormData({
        name: "",
        lastname: "",
        cell: "",
        email: "",
        country: "",
        preferredContact: "Call",
        message: ""
      });

      console.log("Email sent successfully");
    }

  }


  return (



    <div className="contact-wrapper" id="contact">
      <div className="contact-container " >
        <div className="contact-left">
          <h2 className="left-title">Contact CauZen</h2>
          <div className="left-info">
            <div className="info-item">
              <i class="fas fa-map-marker-alt"></i>
              <p>CauZen, Kanadia Road, Indore</p>
            </div>
            <div className="info-item">
<i class="fa-solid fa-phone"></i>
              <p>+91 91 75 71 71 78 </p>
              <p>+91 91 75 74 74 76</p>

            </div>
            <div className="info-item">
              <i class="fas fa-envelope"></i>
              <p>contact@cauzen.com</p>
            </div>
          </div>
        </div>


        <div className="contact-right">
          <form onSubmit={sendEmail}>
            <label> Your Name</label>
            <div className='row'>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className='firstname'
                required

              />
              <input
                type="text"
                name="lastname"
                placeholder="Last Name"
                value={formData.lastname}
                onChange={handleChange}
                className='firstname'
                required
              />
            </div>
            <label> Cell Number</label>
            <input
              type="text"
              name="cell"
              placeholder="Cell Number"
              value={formData.cell}
               onChange={(e) => {
    handleChange(e);
    setStatus(""); 
  }}
  required
/>
{status && <p className="error-message">{status}</p>}
         
            <label>  Email</label>
            <input
              type="email"
              name="email"
              placeholder="Email ID"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label> Your Country</label>
            <select
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            >
              <option value="">Select Country</option>
              <option>India</option>
              <option>USA</option>
              <option>UK</option>
              <option>Australia</option>
              <option>Canada</option>
              <option>Other</option>

            </select>
            <label>Message</label>
            <textarea className='txt'
              name="message"
              placeholder="How can we help you? / Please describe the problem you want to solve. / Please summarise the solution you need?"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <div className="radio-group">
              <label>Preferred Contact:</label>
              <div className="radio-options">
                <label>
                  <input
                    type="radio"
                    name="preferredContact"
                    value="Call"
                    checked={formData.preferredContact === "Call"}
                    onChange={handleChange}
                    required
                  /> Call
                </label>

                <label>
                  <input
                    type="radio"
                    name="preferredContact"
                    value="Email"
                    checked={formData.preferredContact === "Email"}
                    onChange={handleChange}
                    required
                    style={{ marginLeft: '10px' }}
                  /> Email
                </label>

              </div>
            </div>
            <button className='contactbtn' type="submit">Send</button>
            {/* {status && <p className="form-status">{status}</p>} */}
            {/* Custom Modal */}
            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content"
                 onMouseEnter={() => {
        if (hideTimeout) {
          clearTimeout(hideTimeout);
        }
      }}
      onMouseLeave={() => {
        const timeoutId = setTimeout(() => {
          setShowModal(false);
        }, 2000); 
        setHideTimeout(timeoutId);
      }}>
                  <h2>Thank You!</h2>
                  <p>Thank you so much for contacting <strong>CauZen</strong>. Our team has received your request and we will get back to you within 24 hours.</p>
                  <div className='popup-container'>
                    <button onClick={() => setShowModal(false)} className="close-button">Close</button>
                  </div>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>

  );
}

export default Contact;

